__turbopack_context__.v({
  "auxInfo": "YearFilter-module__ZFMRuW__auxInfo",
  "conditionTypeBtns": "YearFilter-module__ZFMRuW__conditionTypeBtns",
  "infoLine": "YearFilter-module__ZFMRuW__infoLine",
  "rangeInput": "YearFilter-module__ZFMRuW__rangeInput",
  "rangeInputControl": "YearFilter-module__ZFMRuW__rangeInputControl",
  "resultCount": "YearFilter-module__ZFMRuW__resultCount",
  "stepperWrapper": "YearFilter-module__ZFMRuW__stepperWrapper",
  "yearFilter": "YearFilter-module__ZFMRuW__yearFilter",
});
